<template>
  <div v-if="showHelper"
       :title="`Selecteer (optioneel) een ${familyMemberOrContactPerson} om onderstaande velden te vullen`"
  >
    <dd-select
      :title="`Invulhulp: gegevens ${familyMemberOrContactPerson}`"
      name="filler-helper"
      :options="familyMembersOptions"
      v-model="selectedFamilyMember"
      @input="fillData"
      class="fill-view-catalog-helper"
      :placeholder="`Selecteer een ${familyMemberOrContactPerson}`"
      :allow-clear="true"
    ></dd-select>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import customerApi from '~/api/customer';
import {DataCatalogPersonEnum, DataCatalogEntityEnum} from "~/pages/insurance/enums";

export default {
  name: "FillViewCatalogWithMemberHelper",
  props: {
    view: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      selectedFamilyMember: null,
      showWithEntityCodes: [
        DataCatalogEntityEnum.INSURED_PERSON,
        DataCatalogEntityEnum.POLICYHOLDER,
      ],
    }
  },
  created() {
    if (this.showHelper === true && this.customerFamily === null) {
      customerApi.findFamily(this.customerId)
          .then((response) => {
            this.setCustomerFamily(response.data);
          });
    }
  },
  methods: {
    ...mapMutations(`$_generic_insurance`, {
      setCustomerFamily: "SET_CUSTOMER_FAMILY",
    }),
    fillData(familyMemberId) {
      const familyMember = this.familyMembers.find(member => String(member.id) === String(familyMemberId));

      if (familyMember === undefined) {
        this.$confirm({
          title: `${this.view.name} gegevens wissen?`,
          content: `Wil je ${this.familyMemberOrContactPerson} gegevens wissen voor ${this.view.name}?`,
          okText: 'Ja',
          cancelText: 'Annuleren',
          onOk: () => {
            this.fillValues(familyMember); // clear values
          },
          onCancel() {
          },
        });
      } else {
        this.fillValues(familyMember);
      }
    },
    fillValues(familyMember) {
      const viewIdx = this.form.views.findIndex(view => view.uuid === this.view.uuid);

      this.fillInputValue(viewIdx, DataCatalogPersonEnum.LAST_NAME, familyMember ? familyMember.last_name : null);
      this.fillInputValue(viewIdx, DataCatalogPersonEnum.INITIALS, familyMember ? familyMember.initials : null);
      this.fillInputValue(viewIdx, DataCatalogPersonEnum.SUFFIX, familyMember ? familyMember.suffix : null);
      this.fillInputValue(viewIdx, DataCatalogPersonEnum.GENDER, this.getMemberCode(familyMember));
      this.fillInputValue(viewIdx, DataCatalogPersonEnum.DOB, familyMember ? familyMember.date_of_birth : null);
    },
    fillInputValue(viewIdx, catalogCode, value) {
      const catalogIdx = this.findCatalogIdx(viewIdx, catalogCode);

      if (catalogIdx !== -1) {
        this.form.views[viewIdx].inputs[catalogIdx].attributes.value = value; // persist to state
      }
    },
    findCatalogIdx(viewIdx, catalogCode) {
      const inputs = this.form.views[viewIdx].inputs;

      // create: object structure
      if (typeof inputs === 'object' && Array.isArray(inputs) === false) {
        return Object.keys(inputs).find(key => inputs[key].code === catalogCode) || -1;
      }

      // edit: array structure
      if (Array.isArray(inputs) === true) {
        return inputs.findIndex(input => input.code === catalogCode);
      }

      return -1; // not found
    },
    getMemberCode(familyMember) {
      if (familyMember && familyMember.is_business) {
        return 'R';
      }

      return this.mapGenderCode(familyMember);
    },
    mapGenderCode(familyMember) {
      if (familyMember === undefined || familyMember === null) {
        return '-1';
      }

      switch (familyMember.sex) {
        case 1:
        case '1':
          return 'M';
        case 0:
        case '0':
          return 'V';
        case 'onbekend':
          return 'O';
        case 'rechtspersoon':
          return 'R';
        default:
          return String(-1);
      }
    },
  },
  computed: {
    ...mapState(`$_generic_insurance`, [
      'customerId',
      'customerFamily',
      'form',
    ]),
    showHelper() {
      return this.showWithEntityCodes.includes(this.view.entity_code);
    },
    customerMain() {
      return this.customerFamily !== null && this.customerFamily.hasOwnProperty('main')
          ? this.customerFamily.main.data : null;
    },
    customerPartner() {
      return this.customerFamily !== null && this.customerFamily.hasOwnProperty('partner')
          ? this.customerFamily.partner.data : null;
    },
    customerChildren() {
      return this.customerFamily !== null && this.customerFamily.hasOwnProperty('children')
          ? this.customerFamily.children.data : null;
    },
    familyMembers() {
      let members = [];

      if (this.customerMain !== null) {
        members.push(this.customerMain);
      }

      if (this.customerPartner !== null) {
        members.push(this.customerPartner);
      }

      if (this.customerChildren !== null) {
        members.push(...this.customerChildren);
      }

      return members;
    },
    mainCustomerIsBusiness() {
      return (this.customerMain !== null && this.customerMain.is_business) || false;
    },
    familyMemberOrContactPerson() {
      return this.mainCustomerIsBusiness ? 'contactpersoon' : 'familielid';
    },
    familyMembersOptions() {
      if (this.mainCustomerIsBusiness) {
        return this.familyMembers.map(member => ({
          value: member.id,
          label: `${member.initials || ''} ${member.suffix || ''} ${member.last_name || ''} (${member.business_name || ''})`
        }));
      }

      return this.familyMembers.map(member => ({ value: member.id, label: member.full_name }));
    }
  },
}
</script>

<style scoped>
.fill-view-catalog-helper >>> label.label {
  color: rgba(72, 72, 72, 0.7);
}

.fill-view-catalog-helper >>> div.ant-select-selection {
  background-color: rgba(233, 241, 251, 0.1);
}

.fill-view-catalog-helper >>> div.ant-select-selection-selected-value {
  color: rgba(72, 72, 72, 0.7);
}
</style>